import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";

const PAGE_BG = "#F6F8FB";

const MarketGrowthPageShell = ({
  title,
  description,
  loading = false,
  error = null,
  empty = false,
  emptyMessage = "داده‌ای برای نمایش وجود ندارد.",
  onRetry,
  children,
}) => (
  <Box sx={{ p: { xs: 2, md: 3 }, background: PAGE_BG, minHeight: "100%" }}>
    <BreadcrumbsComponent />
    <Typography variant="h5" fontWeight={700} sx={{ mt: 1 }}>
      {title}
    </Typography>
    {description ? (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
        {description}
      </Typography>
    ) : null}

    {loading ? (
      <Box display="flex" justifyContent="center" py={6}>
        <CircularProgress />
      </Box>
    ) : null}

    {!loading && error ? (
      <Alert
        severity="error"
        sx={{ mb: 2 }}
        action={
          onRetry ? (
            <Button color="inherit" size="small" onClick={onRetry}>
              تلاش مجدد
            </Button>
          ) : null
        }
      >
        {error}
      </Alert>
    ) : null}

    {!loading && !error && empty ? (
      <Card variant="outlined">
        <CardContent>
          <Alert severity="info">{emptyMessage}</Alert>
        </CardContent>
      </Card>
    ) : null}

    {!loading && !error && !empty ? children : null}
  </Box>
);

export default MarketGrowthPageShell;
